type EnvType = {
  REACT_APP_CONTRACT_ADDRESS: string;
  REACT_APP_SUBGRAPH_GRAPHQL: string;
  REACT_APP_SUBGRAPH_API_KEY: string;
  REACT_APP_CHAIN_ID: string;
  REACT_APP_WALLET_CONNECT_PROJECT_ID: string;
};
export const env: EnvType =
  process.env.NODE_ENV === "production" ? (window as any)["env"] : process.env;
